import grapesjs from 'drapcode-builder';
import loadBlocks from './blocks';
import loadComponents from './components';
import { dateRangePagination } from './consts';
export default grapesjs.plugins.add('gjs-date-range-filter', (editor, opts = {}) => {
  let c = opts;
  let defaults = {
    blocks: [dateRangePagination],
    defaultStyle: true,
    pfx: 'date-range-filter',
    label: 'Date Range Filter',
    category: 'CMS',
  };
  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }
  loadComponents(editor, c);
  loadBlocks(editor, c);
});
